export const locale = {
  /**Название месяцов */
  monthNames: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ],
  /**Сокращенные названия дней недели */
  weekDayShortNames: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
};
